import UploadPromoForm from './UploadPromoForm';

export default UploadPromoForm;
